module.exports = __webpack_public_path__ + "img/soft_b.ba98c21b.png";